module.exports = __webpack_public_path__ + "fonts/Raleway-BoldItalic.fb35369f.ttf";